import script from "./TablePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TablePage.vue?vue&type=script&setup=true&lang=js"

import "./TablePage.vue?vue&type=style&index=0&id=575c9c99&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-575c9c99"]])

export default __exports__